import {
  getCollabsStats,
  getCollabsStatsByDate,
  getSocialMediaStats,
} from "services/SauceService";

export async function reportLoader(props: any) {
  const url = new URL(props.request.url);
  const businessId = url.searchParams.get("businessId");
  const venueUuid = url.searchParams.get("venueUuid");
  const startDate = url.searchParams.get("startDate");
  const endDate = url.searchParams.get("endDate");

  const collabIds = url.searchParams.getAll("collabId");

  const params = {
    collabIds,
  };

  const paramsByBusiness = {
    businessId: businessId,
    startDate,
    endDate,
    venueUuid,
  };

  const [reportInfo, comments, socialMediaStats]: any = await Promise.all([
    getCollabsStats(collabIds.length ? params : paramsByBusiness),
    getCollabsStatsByDate(collabIds.length ? params : paramsByBusiness),
    getSocialMediaStats(paramsByBusiness),
  ]);

  return {
    ...reportInfo,
    ...comments,
    ...socialMediaStats,
    businessId,
    venueUuid,
    startDate,
    endDate,
  };
}
